import React from "react";
import { textTranslate } from "../../../../utils/i18n";

const OPEN_SERVICE_ORDER_STATUSES = ["sos_new", "sos_in_progress"];

export const hasOpenServiceOrder = (serviceOrders = []) =>
  serviceOrders.some((order) => OPEN_SERVICE_ORDER_STATUSES.includes(order.status));

const OpenServiceOrderIndicator = ({ serviceOrders, onClick }) => {
  if (!hasOpenServiceOrder(serviceOrders)) return null;

  const tooltip = textTranslate("openServiceOrderTooltip");
  return (
    <button type="button" className="btn btn-link p-0 ml-2" title={tooltip} aria-label={tooltip} onClick={onClick}>
      <i className="fa fa-wrench" style={{ color: "#2299A3", fontSize: "20px" }} aria-hidden="true"></i>
    </button>
  );
};

export default OpenServiceOrderIndicator;
